// /src/pages/AdminLogin.jsx
import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { Lock, Eye, EyeOff, Settings } from 'lucide-react'
import { useAuth } from '../utils/authContext'

const AdminLogin = () => {
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  })
  const [showPassword, setShowPassword] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState('')
  const navigate = useNavigate()
  const { login } = useAuth()

  const handleInputChange = (e) => {
    const { name, value } = e.target
    setFormData(prev => ({
      ...prev,
      [name]: value
    }))
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setIsLoading(true)
    setError('')

    console.log('Login attempt:', formData.email, formData.password)

    try {
      const result = await login(formData.email, formData.password)
      
      if (result.success) {
        console.log('Login successful')
        navigate('/admin')
      } else {
        console.log('Login failed:', result.error)
        setError(result.error || 'Invalid email or password')
      }
    } catch (error) {
      console.error('Login error:', error)
      setError('Network error. Please try again.')
    }
    
    setIsLoading(false)
  }

  return (
    <div className="min-h-screen bg-forest-50 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div className="text-center">
          <div className="flex items-center justify-center mb-6">
            <img src="/logolong.png" alt="PalmGarden Reforestation Logo" className="h-12 w-auto object-contain" />
          </div>
          <h2 className="text-3xl font-bold text-forest-900 mb-2">
            Admin Login
          </h2>
        </div>

        <div className="bg-white py-8 px-6 shadow-lg rounded-lg border border-forest-200">
          <form className="space-y-6" onSubmit={handleSubmit}>
            {error && (
              <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-md">
                {error}
              </div>
            )}

            <div>
              <label htmlFor="email" className="block text-sm font-medium text-forest-700 mb-2">
                Email Address
              </label>
              <input
                id="email"
                name="email"
                type="email"
                required
                value={formData.email}
                onChange={handleInputChange}
                className="input-field"
                placeholder="admin@palmgarden.com"
              />
            </div>

            <div>
              <label htmlFor="password" className="block text-sm font-medium text-forest-700 mb-2">
                Password
              </label>
              <div className="relative">
                <input
                  id="password"
                  name="password"
                  type={showPassword ? 'text' : 'password'}
                  required
                  value={formData.password}
                  onChange={handleInputChange}
                  className="input-field pr-10"
                  placeholder="Enter your password"
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="absolute inset-y-0 right-0 pr-3 flex items-center"
                >
                  {showPassword ? (
                    <EyeOff className="h-5 w-5 text-forest-400" />
                  ) : (
                    <Eye className="h-5 w-5 text-forest-400" />
                  )}
                </button>
              </div>
            </div>

            <div>
              <button
                type="submit"
                disabled={isLoading}
                className="btn-primary w-full flex items-center justify-center space-x-2"
              >
                {isLoading ? (
                  <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white"></div>
                ) : (
                  <Lock className="h-5 w-5" />
                )}
                <span>{isLoading ? 'Signing in...' : 'Sign In'}</span>
              </button>
            </div>
          </form>

          <div className="mt-6 text-center">
            <p className="text-sm text-forest-500">
              Demo credentials: admin@palmgarden.com / admin123
            </p>
          </div>
        </div>

        <div className="text-center">
          <Link
            to="/"
            className="text-primary-600 hover:text-primary-700 font-medium"
          >
            ← Back to PalmGarden PublicSite
          </Link>
        </div>
      </div>
    </div>
  )
}

export default AdminLogin 